import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useRef, useMemo } from 'react';
import { flushSync } from 'react-dom';

const Ctx = createContext(undefined);
function SliderA11yProvider({ children, }) {
    const [isSliderFocused, setIsSliderFocused] = useState(false);
    const singleRef = useRef(null);
    const lowerRef = useRef(null);
    const upperRef = useRef(null);
    const lowerThumbRef = useRef(null);
    const upperThumbRef = useRef(null);
    const setSingleInputRef = (el) => (singleRef.current = el);
    const setRangeLowerInputRef = (el) => (lowerRef.current = el);
    const setRangeUpperInputRef = (el) => (upperRef.current = el);
    const setLowerThumbRef = (el) => {
        lowerThumbRef.current = el;
    };
    const setUpperThumbRef = (el) => {
        upperThumbRef.current = el;
    };
    const focusLowerThumb = () => {
        requestAnimationFrame(() => { var _a; return (_a = lowerThumbRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
    };
    const focusPrevInputFor = (thumb) => {
        const target = thumb === "single"
            ? singleRef.current
            : thumb === "lower"
                ? upperRef.current
                : lowerRef.current;
        flushSync(() => setIsSliderFocused(false));
        requestAnimationFrame(() => target === null || target === void 0 ? void 0 : target.focus());
    };
    const value = useMemo(() => ({
        isSliderFocused,
        setIsSliderFocused,
        setSingleInputRef,
        setRangeLowerInputRef,
        setRangeUpperInputRef,
        focusPrevInputFor,
        setLowerThumbRef,
        setUpperThumbRef,
        focusLowerThumb,
    }), [isSliderFocused]);
    return jsx(Ctx.Provider, { value: value, children: children });
}
const useSliderA11y = () => {
    const ctx = useContext(Ctx);
    if (!ctx)
        throw new Error("useSliderA11y must be used within SliderA11yProvider");
    return ctx;
};

export { SliderA11yProvider, useSliderA11y };
